export const IMAGE_PATH = 'https://mdsorthotompublic.blob.core.windows.net/mds-files/';
export const FILE_PATH = 'https://mdsorthotompublic.blob.core.windows.net/mds-files/';
